module.exports = __webpack_public_path__ + "static/media/oneNote_ai.3acd3ddf.png";